import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, Sparkles } from "lucide-react";

const stagger = {
  hidden: {},
  show: { transition: { staggerChildren: 0.08, delayChildren: 0.15 } },
};
const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
};

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-36 pb-24 md:pt-44 md:pb-32 overflow-hidden grain"
    >
      {/* Background grid */}
      <div className="absolute inset-0 hero-grid-bg pointer-events-none" />
      {/* Orange glow accent */}
      <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-[#FF4500]/15 blur-[160px] pointer-events-none" />
      <div className="absolute -bottom-32 -left-40 w-[500px] h-[500px] rounded-full bg-[#A7F3D0]/[0.04] blur-[140px] pointer-events-none" />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        <motion.div
          variants={stagger}
          initial="hidden"
          animate="show"
          className="max-w-5xl mx-auto text-center flex flex-col items-center"
        >
          <motion.div variants={fadeUp} className="mb-8 inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#2A2E3D] bg-[#151821]/60 backdrop-blur">
            <Sparkles className="w-3.5 h-3.5 text-[#FF4500]" />
            <span className="text-xs tracking-[0.25em] uppercase text-[#9CA3AF]">
              Performance-based outbound, end-to-end
            </span>
          </motion.div>

          <motion.h1
            variants={fadeUp}
            data-testid="hero-headline"
            className="font-editorial font-light leading-[0.95] tracking-tighter text-[#EDEDED] text-[2.6rem] sm:text-6xl lg:text-[6rem] whitespace-nowrap"
          >
            <span className="italic text-[#FF4500]">Qualified</span> meetings,
            <br />
            booked on your calendar.
          </motion.h1>

          <motion.p
            variants={fadeUp}
            className="mt-8 max-w-2xl text-lg sm:text-xl text-[#9CA3AF] leading-relaxed"
          >
            Prospectivly is a fully-managed outbound engine that does deep ICP research,
            BANT-aligned qualification and smart multi-channel outreach, then drops
            pre-qualified, high-intent meetings directly on your reps&rsquo; calendars.
          </motion.p>

          <motion.div variants={fadeUp} className="mt-12 flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="#book"
              data-testid="hero-primary-cta"
              className="inline-flex items-center justify-center gap-2 bg-[#FF4500] hover:bg-[#E03C00] text-white px-8 py-4 rounded-full font-medium transition-all duration-300 hover:shadow-[0_0_32px_rgba(255,69,0,0.4)]"
            >
              Book a strategy call
              <ArrowUpRight className="w-5 h-5" />
            </a>
            <a
              href="#case-study"
              data-testid="hero-secondary-cta"
              className="inline-flex items-center justify-center gap-2 bg-transparent border border-[#2A2E3D] hover:border-[#EDEDED] text-[#EDEDED] px-8 py-4 rounded-full font-medium transition-all duration-300"
            >
              See real customer proof
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
